import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

const VIDE = { statut: 'a_faire', exemple: '', preuves: [] };
const ETAT_VIDE = { ind: {}, check: {} };
const basculer = (liste, k) => (liste.includes(k) ? liste.filter((x) => x !== k) : [...liste, k]);
const envoyer = (etat) => axios.put('/guide-bpjeps/ma-progression', { etat });

// Progression enregistrée sur le compte ; uid = progression d'un stagiaire consultée en lecture seule (commentable par l'équipe)
export const useGuideProgression = (uid, equipe) => {
  const [etat, setEtat] = useState(null);
  const [commentaires, setCommentaires] = useState({});
  const [sauvegarde, setSauvegarde] = useState('ok');
  const [bloque, setBloque] = useState(false);
  const modifie = useRef(false);
  const enAttente = useRef(null);
  const lecture = Boolean(uid) || bloque;

  useEffect(() => {
    if (enAttente.current) { envoyer(enAttente.current).catch(() => {}); enAttente.current = null; }
    setEtat(null);
    modifie.current = false;
    axios.get(uid ? `/guide-bpjeps/suivi/${uid}` : '/guide-bpjeps/ma-progression')
      .then(({ data }) => { setBloque(false); setCommentaires(data.commentaires || {}); setEtat({ ...ETAT_VIDE, ...data.etat }); })
      .catch(() => { setBloque(true); setSauvegarde('erreur_chargement'); setEtat(ETAT_VIDE); });
  }, [uid]);

  useEffect(() => {
    if (lecture || !etat || !modifie.current) return undefined;
    setSauvegarde('en_cours');
    enAttente.current = etat;
    const t = setTimeout(() => {
      enAttente.current = null;
      envoyer(etat).then(() => setSauvegarde('ok')).catch(() => setSauvegarde('erreur'));
    }, 800);
    return () => clearTimeout(t);
  }, [etat, lecture]);

  useEffect(() => () => { if (enAttente.current) envoyer(enAttente.current).catch(() => {}); }, []);

  const changer = useCallback((f) => { if (lecture) return; modifie.current = true; setEtat(f); }, [lecture]);
  const ind = useCallback((id) => ({ ...VIDE, ...etat?.ind[id] }), [etat]);
  const majInd = useCallback((id, patch) => changer((e) => ({ ...e, ind: { ...e.ind, [id]: { ...VIDE, ...e.ind[id], ...patch } } })), [changer]);
  const basculerPreuve = useCallback((id, k) => changer((e) => {
    const i = { ...VIDE, ...e.ind[id] };
    return { ...e, ind: { ...e.ind, [id]: { ...i, preuves: basculer(i.preuves, k) } } };
  }), [changer]);
  const basculerCheck = useCallback((bloc, k) => changer((e) => ({ ...e, check: { ...e.check, [bloc]: basculer(e.check[bloc] || [], k) } })), [changer]);
  const reinitialiser = useCallback(() => changer(() => ETAT_VIDE), [changer]);
  const majCommentaire = useCallback((id, com) => setCommentaires((c) => {
    const reste = { ...c };
    delete reste[id];
    return com ? { ...reste, [id]: com } : reste;
  }), []);
  const compte = useCallback((ids) => ({
    pret: ids.filter((id) => etat?.ind[id]?.statut === 'pret').length,
    enCours: ids.filter((id) => etat?.ind[id]?.statut === 'en_cours').length,
    total: ids.length,
  }), [etat]);

  return { etat: etat || ETAT_VIDE, charge: etat !== null, lecture, sauvegarde, ind, majInd, basculerPreuve, basculerCheck, reinitialiser, compte,
    uid, commentaires, majCommentaire, peutCommenter: Boolean(uid) && Boolean(equipe) };
};
